import { useEffect, useState } from "react";
import ErrorIcon from "@mui/icons-material/Error";
import {
  ICategoriesValidationInput,
  IChangeEvent,
  IInputEmail,
} from "../../../interfaces/IInput";

export default (props: IInputEmail) => {
  const {
    placeholder,
    layer,
    required,
    onValueChange,
    onPropertyChange,
    onPermaValues,
    layerInvisible,
    errorPosition,
    validacion,
    disabled,
    setValue,
    defaultValue,
    requerido, 
    datoRequerido, 
  } = props;

  const [triggerError, setTriggerError] = useState<boolean>(false);
  const [eventValidation, setEventValidation] = useState<string>("initial");
  const [categoriesValidation] = useState<ICategoriesValidationInput | any>({
    success: "input-success",
    error: "input-error",
    initial: "input-initial",
  });
  const [messageError, setMessageError] = useState<string | undefined>(
    undefined
  );
  const [emailText, setEmailText] = useState<string>("");

  useEffect(() => {
    if(defaultValue) {
      if (defaultValue.match(/^[a-zA-Z0-9ñÑ._%+-]+@[a-zA-Z0-9ñÑ.-]+\.[a-zA-Z]{2,}$/)) {
        setEmailText(defaultValue)
      }
    }
  }, [defaultValue])

  const handleChangeEventError = (event: IChangeEvent) => {
    const { value } = event;
    let trigger: boolean = false;
    let eventValidation: string = "initial";
    let emailInput: string = value;

    if (required) {
      trigger = value !== "" ? false : true;
      eventValidation = value !== "" ? "success" : "error";
    }

    if (!required) {
      eventValidation = value !== "" ? "success" : "initial";
    }

    if (required) {
      if (emailInput === "") {
        setMessageError(`Dato obligatorio`);
        trigger = true;
        eventValidation = "error";
      }
    }

    if (emailInput !== "") {
      if (!emailInput.match(/^[a-zA-Z0-9ñÑ._%+-]+@[a-zA-Z0-9ñÑ.-]+\.[a-zA-Z]{2,}$/)) {
        setMessageError(`no tiene el formato adecuado`);
        trigger = true;
        eventValidation = "error";
      } 
    }

    setEventValidation(eventValidation);
    typeof validacion === "function" &&
      validacion(eventValidation == "success" ? false : true);
    setTriggerError(trigger);

    if (onPermaValues && onPropertyChange && onValueChange) {
      const permaValues = { ...onPermaValues };
      permaValues[onPropertyChange] = {
        value: emailInput,
        valid: trigger ? false : true,
      };
      onValueChange(permaValues);
    }

    setEmailText(emailInput);
    typeof setValue == "function" && setValue(emailInput);
  };

  return (
    <div className={`${required ? "cols-required" : "cols-not-required"}`}>
      <div style={{ display: "flex" }}>
        {!layerInvisible && <label className="layer">{`${layer}`}</label>}
        {triggerError && ["up", undefined].includes(errorPosition) && (
          <span className="layer-error">{messageError}</span>
        )}
      </div>

      <input
        type="text"
        placeholder={placeholder}
        className={`${categoriesValidation[eventValidation]} ${
          disabled ? "disabled" : ""
        }`}
        required={required}
        value={emailText}
        onChange={({ target }) =>
          handleChangeEventError({ value: target.value })
        }
        onBlur={({ target }) => handleChangeEventError({ value: target.value })}
        disabled={disabled}
      />
      {triggerError && errorPosition == "down" && (
        <span className="layer-error down">{messageError}</span>
      )}
    </div>
  );
};
